import Link from "next/link";
import styles from './MenuAuxiliar.module.css';

const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
};

const MenuAuxiliar = () => {
    return (
        <nav className={styles.navMenuAuxiliar}>
            <ul>
                <li>
                    <Link
                        className={styles.linkAuxiliar}
                        href="/Suporte/"
                        onClick={scrollToTop}
                        aria-label="Acessar Página Suporte"
                    >
                        Suporte
                    </Link>
                </li>
                <li>
                    <Link
                        className={styles.linkAuxiliar}
                        href="/Acessibilidade/"
                        onClick={scrollToTop}
                        aria-label="Acessar Página Acessibilidade"
                    >
                        Acessibilidade
                    </Link>
                </li>
                <li>
                    <Link
                        className={styles.linkAuxiliar}
                        href="/PoliticaPrivacidade/"
                        onClick={scrollToTop}
                        aria-label="Acessar Página Política de Privacidade"
                    >
                        Política de Privacidade
                    </Link>
                </li>
                <li>
                    <Link
                        className={styles.linkAuxiliar}
                        href="/TermosCondicoes/"
                        onClick={scrollToTop}
                        aria-label="Acessar Página Termos e Condições"
                    >
                        Termos e Condições
                    </Link>
                </li>
            </ul>
        </nav>
    );
};

export default MenuAuxiliar;